import styled from "styled-components";
import { space } from "styled-system";
import { themeGet } from "@styled";

export const LanguageWrap = styled.div`
    ${space}
    color: ${themeGet("colors.text")};
`;
